import React from "react";
import SEO from "@components/seo";
import Layout from "@components/layout";
import MenuBar from "@components/menuBar/MenuBar";
import AddressCard from "./AddressCard";
import TabBar from "./TabBar";

export default function StateLocations({ locations, currentState }) {
  return (
    <>
      <SEO title="Giftcards Locations" />
      <MenuBar/>
      <Layout>
      <section className="min-h-screen bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
          <h2 className="text-center text-3xl font-extrabold text-gray-900">
            Locations
          </h2>
          <TabBar current={currentState} />
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {locations && locations.map((location) => {
              return (
                <AddressCard key={location.id}
                  name={location.name}
                  streetAddress={location.streetAddress}
                  suburb={location.suburb}
                  state={location.state}
                  postcode={location.postcode}
                  webstore={location.webstore}
                  phone={location.phone}
                />
              );
            })}
          </div>
        </div>
      </section>
      </Layout>
    </>
  )
}
